import React from 'react';
import { ConstCss } from '../../const/Const';
import { ReactComponent as FilterIcon } from '../../svg/filterIcon.svg'

const IconFilter = () => {
    return (
        <div style={{ ...ConstCss.flexCenter, cursor: 'pointer' }}>
            <FilterIcon />
        </div>
    );
}

export default IconFilter;